var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ad35ce1fdbcd63128b056f7467112b656672a936"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"ad35ce1fdbcd63128b056f7467112b656672a936"};
      